// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vendors_wrapper__1wBJA","alerts":"vendors_alerts__1y9Fz","container":"vendors_container__1BqyO","header":"vendors_header__3MzCt","content":"vendors_content__2ytFi"};